import { Typography as AntdTypography } from "antd";

import type { AvE2EProps } from "@av/components/types";
import { CustomLink } from "./Link";
import { CustomParagraph } from "./Paragraph";
import { CustomText } from "./Text";
import { CustomTitle } from "./title/Title";

type TypographyProps = React.ComponentProps<typeof AntdTypography> & AvE2EProps;

function CustomTypography(props: TypographyProps) {
  const { testIdPrefix, children, ...restProps } = props;

  return (
    <AntdTypography data-testid={testIdPrefix + "-typography"} {...restProps}>
      {children}
    </AntdTypography>
  );
}

export const Typography = Object.assign(CustomTypography, {
  Title: CustomTitle,
  Paragraph: CustomParagraph,
  Text: CustomText,
  Link: CustomLink,
});
